var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "800" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v(_vm._s(_vm.form.id ? "edit" : "add"))]),
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.form.id
                          ? "Editar Experiencia de Trabajo"
                          : "Crear Experiencia de Trabajo"
                      ) +
                      "\n      "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md126: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Institución",
                                  rules: _vm.$validate(["required"]),
                                  maxlength: "250",
                                  required: ""
                                },
                                model: {
                                  value: _vm.form.institucion,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "institucion", $$v)
                                  },
                                  expression: "form.institucion"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.paises,
                                  "item-text": "pais",
                                  "item-value": function(val) {
                                    return parseInt(val.id)
                                  },
                                  label: "País",
                                  rules: _vm.$validate(["required"])
                                },
                                model: {
                                  value: _vm.form.id_pais,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "id_pais", $$v)
                                  },
                                  expression: "form.id_pais"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md12: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Puesto",
                                  rules: _vm.$validate(["required"]),
                                  maxlength: "250",
                                  required: ""
                                },
                                model: {
                                  value: _vm.form.puesto,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "puesto", $$v)
                                  },
                                  expression: "form.puesto"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "date",
                                  label: "Fecha de inicio",
                                  rules: _vm.$validate(["required"]),
                                  required: ""
                                },
                                model: {
                                  value: _vm.form.fecha_inicio,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_inicio", $$v)
                                  },
                                  expression: "form.fecha_inicio"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "date",
                                  label: "Fecha de conclusión"
                                },
                                model: {
                                  value: _vm.form.fecha_conclusion,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_conclusion", $$v)
                                  },
                                  expression: "form.fecha_conclusion"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("p", [_vm._v("Tipo Empresa")]),
                              _vm._v(" "),
                              _c(
                                "v-radio-group",
                                {
                                  attrs: {
                                    row: "",
                                    rules: _vm.$validate(["required"]),
                                    required: ""
                                  },
                                  model: {
                                    value: _vm.form.id_parametro_tipo_empresa,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "id_parametro_tipo_empresa",
                                        $$v
                                      )
                                    },
                                    expression: "form.id_parametro_tipo_empresa"
                                  }
                                },
                                [
                                  _c("v-radio", {
                                    attrs: { label: "Pública", value: 1 }
                                  }),
                                  _vm._v(" "),
                                  _c("v-radio", {
                                    attrs: { label: "Privada", value: 2 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "" } },
                            [
                              _c("p", [_vm._v("Personal Dependiente")]),
                              _vm._v(" "),
                              _c(
                                "v-radio-group",
                                {
                                  attrs: { row: "" },
                                  model: {
                                    value: _vm.form.personal_dependiente,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "personal_dependiente",
                                        $$v
                                      )
                                    },
                                    expression: "form.personal_dependiente"
                                  }
                                },
                                [
                                  _c("v-radio", {
                                    attrs: { label: "Sí", value: 2 }
                                  }),
                                  _vm._v(" "),
                                  _c("v-radio", {
                                    attrs: { label: "No", value: 3 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "number",
                                  label: "Nro de personas dependientes",
                                  disabled: _vm.form.personal_dependiente === 3,
                                  rules: [
                                    function(v) {
                                      if (v < 0) {
                                        return "El número no tiene que ser negativo."
                                      }

                                      return true
                                    }
                                  ]
                                },
                                model: {
                                  value: _vm.form.nro_personas_dependientes,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "nro_personas_dependientes",
                                      $$v
                                    )
                                  },
                                  expression: "form.nro_personas_dependientes"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md12: "" } },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  label: "Funciones principales",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  maxlength: "1200"
                                },
                                model: {
                                  value: _vm.form.funciones_principales,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "funciones_principales",
                                      $$v
                                    )
                                  },
                                  expression: "form.funciones_principales"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md12: "" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.motivo_finalizacion,
                                  "item-text": "valor",
                                  "item-value": function(x) {
                                    return parseInt(x.id)
                                  },
                                  label:
                                    "Motivo de finalización del vínculo laboral o continuidad en el cargo",
                                  rules: _vm.$validate(["required"])
                                },
                                model: {
                                  value:
                                    _vm.form.id_parametro_motivo_finalizacion,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "id_parametro_motivo_finalizacion",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.id_parametro_motivo_finalizacion"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md12: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label:
                                    "Explicar brevemente el motivo de la  finalización del vínculo laboral",
                                  maxlength: "250"
                                },
                                model: {
                                  value: _vm.form.resumen_motivo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "resumen_motivo", $$v)
                                  },
                                  expression: "form.resumen_motivo"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { md12: "" } }, [
                            _c("input", {
                              ref: "file",
                              attrs: {
                                id: "input",
                                type: "file",
                                accept: "image/*, application/pdf",
                                rules: _vm.$validate(["required"]),
                                required: ""
                              },
                              on: {
                                change: function($event) {
                                  return _vm.handleFileUpload()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.error
                              ? _c("p", { staticClass: "red--text body-1" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.mensjageerror) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("small", { staticClass: "error--text text-required" }, [
                    _vm._v("* Los campos son obligatorios")
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n        "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        type: "submit",
                        loading: _vm.loading,
                        disabled: !_vm.valid
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("check")]),
                      _vm._v(" " + _vm._s(_vm.$t("common.save")) + "\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9f7d9324", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f7d9324","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/ficha_personal/dialogs/CrearActualizarExperienciaTrabajo.vue
// module id = null
// module chunks = 